import { Navigate } from "react-router-dom";
import ErrorPage from "components/ErrorPage";
import Loading from "components/Loading";
import { loginUser, useSystemAuthDispatch, useSystemAuthState } from "auth/SystemAuth/context/systemToSystemAuth";
import { useQuery } from "react-query";
import { useGetRoles }  from "hooks/queries";

const Account = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("token") || localStorage.getItem("customerToken");
  
  const authDispatch = useSystemAuthDispatch();
  const { loading, errorMessage, user } = useSystemAuthState();
  
  const {isLoading, data} = useGetRoles();

  useQuery("loginUser", async () => {
    await loginUser(authDispatch, token??"");
  }, {refetchOnMount: false});

  if (loading || isLoading || data === undefined) return <Loading />;

  if (errorMessage || !token) return <ErrorPage />;
  // checks that the role has System Admin to determine the page
  if(data.includes("SA")){
    return user ? <Navigate to="/home" replace /> : <Loading />;
  } else {
    return user ? <Navigate to="/home" replace /> : <Loading />;
  }
};

export default Account;
